import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { IImgMediaDto } from 'src/app/core/dtos/interfaces/i-img-media-dto';
import { IVideoMediaDto } from 'src/app/core/dtos/interfaces/i-video-media-dto';
import { MediaTypes } from '../../enums/media-types';
import { DialogService } from '../../../shared/services/dialog.service';
import { ImgOrVideo, MediaType } from '../../types/media-type';
import { MediaAdderDialogComponent } from '../media-adder-dialog/media-adder-dialog.component';
import { FormArray, FormControl } from '@angular/forms';

@Component({
  selector: 'app-media-adder',
  templateUrl: './media-adder.component.html',
  styleUrls: ['./media-adder.component.scss'],
})
export class MediaAdderComponent {
  @Input() sectionImgsFormControl: FormArray;
  @Input() sectionVideosFormControl: FormArray;
  @Input() addMediaLabel: string;
  @Input() isMainMedia: boolean = false;
  @Input() mainMediaLabel: string = 'Main Media';
  @Input() isDisabled: boolean;
  @Input() displayImageOnWebsiteControl?: FormControl<boolean>;
  @Input() showCaption?: boolean = true;
  @Input() isSlide?: boolean = false;
  @Output() handleInsertImg = new EventEmitter<IImgMediaDto>();
  @Output() handleInsertVideo = new EventEmitter<IImgMediaDto>();
  @Output() handleRemoveImg = new EventEmitter<IImgMediaDto>();
  @Output() handleRemoveVideo = new EventEmitter<IVideoMediaDto>();

  ADD_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: (newImgs: ImgOrVideo[]) => {
      this.sectionImgsFormControl.clear();
      newImgs.forEach((ni) =>
        this.sectionImgsFormControl.push(new FormControl(ni))
      );
    },
    [MediaTypes.VIDEO]: (newVideos: ImgOrVideo[]) => {
      this.sectionVideosFormControl.clear();
      newVideos.forEach((nv) =>
        this.sectionVideosFormControl.push(new FormControl(nv))
      );
    },
  };

  REMOVE_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: ({
      mediaToRemove,
      mediaIndexToRemove,
    }: {
      mediaToRemove: IImgMediaDto;
      mediaIndexToRemove: number;
    }) => {
      this.sectionImgsFormControl.removeAt(mediaIndexToRemove);
      this.handleRemoveImg.emit(mediaToRemove);
    },
    [MediaTypes.VIDEO]: ({
      mediaToRemove,
      mediaIndexToRemove,
    }: {
      mediaToRemove: IVideoMediaDto;
      mediaIndexToRemove: number;
    }) => {
      this.sectionVideosFormControl.removeAt(mediaIndexToRemove);
      this.handleRemoveVideo.emit(mediaToRemove);
    },
  };

  INSERT_MEDIA_TYPE_HANDLERS = {
    [MediaTypes.IMAGE]: this.handleInsertImg,
    [MediaTypes.VIDEO]: this.handleInsertVideo,
  };

  MEDIA_TYPES = MediaTypes;

  constructor(
    private dialogService: DialogService,
    @Inject('Window') private window: Window
  ) {}

  changeCaption(value: string, index: number) {
    let img: IImgMediaDto = { ...this.sectionImgsFormControl.at(index).value };
    img.caption = value;
    this.sectionImgsFormControl.at(index).patchValue(img);
  }

  onAddMedia(mediaType: MediaType): void {
    this.dialogService
      .openCustomComponentDialog(
        MediaAdderDialogComponent,
        {
          mediaType,
          prevSelectedMedias:
            mediaType === this.MEDIA_TYPES.IMAGE
              ? this.sectionImgsFormControl.value
              : this.sectionVideosFormControl.value,
          canSelectMultiple: !(this.isMainMedia || this.isSlide),
        },
        true,
        { width: '95%', height: '95vh', maxWidth: '95vw' }
      )
      .afterClosed()
      .subscribe(
        ({
          actionResult,
          data,
        }: {
          actionResult: boolean;
          data: ImgOrVideo[];
        }) => {
          if (actionResult) {
            this.ADD_MEDIA_TYPE_HANDLERS[mediaType](data);
          }
        }
      );
  }

  onPlayMediaVideo(event: PointerEvent, videoToPlay: IVideoMediaDto): void {
    event.preventDefault();
    this.window.open(
      `http://view.vzaar.com/${videoToPlay.guid}/video`,
      'videoPlayer',
      'width=640,height=360,menubar=no'
    );
  }
}
